import React, { useState } from "react";
import { InputText } from "@vernost_dev/vms-react-components/dist/InputText";

const VmsInputText = (props) => {
  const { placeholder, value, messageMode, msgText, label, onKeyDown = () => { }, name, type, id, onClick, autocomplete = "off", leftView, rightView, readOnly, className, onBlur = () => { }, onFocus = () => { }, onChange = () => { }, tabIndex, maxLength, disabled, isLoading, showStaticLabel = false } = props;
  const [showLabel, setShowlabel] = useState(showStaticLabel ? true : false)
  const showPlaceHolder = true
  const handleChange = (e) => {
    const sanitizedValue = e?.target?.value
    return sanitizedValue;
  };

  return (
    <InputText
      readOnly={readOnly}
      msgText={msgText}
      leftView={leftView}
      messageMode={messageMode}
      // label={""}
      autocomplete={autocomplete}
      rightView={rightView}
      value={value}
      name={name}
      type={type}
      id={id}
      // placeholder={placeholder}
      secondPlaceHolder={""}
      additionalClassName={className}
      onClick={onClick}
      placeholder={showPlaceHolder ? !showLabel && `${placeholder || label || ""}` : `${placeholder}`}
      label={showPlaceHolder ? (showLabel || value?.length > 0) && `${placeholder || label || ""}` : label}
      onChange={(e) => onChange({ ...e, target: { ...e.target, value: handleChange(e) } })}
      onBlur={(e) => {
        if (!showStaticLabel) {
          setShowlabel(false)
        }

        onBlur(e)
      }}
      onFocus={(e) => {
        setShowlabel(true)
        onFocus(e)
      }}
      tabIndex={tabIndex}
      maxLength={maxLength}
      disabled={disabled}
      isLoading={isLoading}
    />
  );
};

export { VmsInputText };